// extracted by mini-css-extract-plugin
export var animationContainer = "_ma-0";
export var footer = "_ma-1";
export var gray = "_ma-2";
export var lineItem = "_ma-3";
export var lineItemImage = "_ma-4";
export var lineItemInfo = "_ma-5";
export var lineItemText = "_ma-6";
export var lineItems = "_ma-7";
export var modalContent = "_ma-8";
export var options = "_ma-9";
export var orderName = "_ma-a";
export var refundAmount = "_ma-b";